"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Eventing = /*#__PURE__*/function () {
  function Eventing() {
    _classCallCheck(this, Eventing);

    _defineProperty(this, "events", {});
  }

  _createClass(Eventing, [{
    key: "on",
    value: function on(eventName, cb) {
      var handlers = this.events[eventName] || [];
      handlers.push(cb);
      this.events[eventName] = handlers;
    }
  }, {
    key: "off",
    value: function off(evt, fn) {
      // console.log(evt, fn);
      var allFn = this.events[evt];
      var index = allFn.findIndex(function (fun) {
        return fun == fn;
      });
      allFn.splice(index, 1);
      allFn.forEach(function (fn) {
        console.log(fn);
      });
    }
  }, {
    key: "trigger",
    value: function trigger(eventName, args) {
      var opt = args ? args : [];
      var handlers = this.events[eventName];

      if (!handlers || handlers.length === 0) {
        return;
      }

      handlers.forEach(function (cb) {
        cb(opt);
      });
    }
  }]);

  return Eventing;
}();

var instance = new Eventing();
Object.freeze(instance);
var _default = instance;
exports["default"] = _default;